import { sharedMessages, useIntlDeprecated } from '@faceup/localization'
import { useNotification } from '@faceup/ui-base'
import { captureException } from '@sentry/react'
import { useCallback } from 'react'

// It's not best place, @faceup/crypto should be used instead
export const useCryptoErrorHandler = () => {
  const { formatMessage } = useIntlDeprecated()
  const notification = useNotification()

  // biome-ignore lint/correctness/useExhaustiveDependencies: Notification.error is stable from useNotification hook
  return useCallback(
    (payload: string, context?: Parameters<typeof captureException>[1]) => {
      console.error(payload)
      captureException(new Error(payload), context)
      notification.error({
        message: formatMessage(sharedMessages.encryptionError),
        description: payload,
      })
    },
    [formatMessage]
  )
}
